export enum IconSizes {
  Big = 32,
  Medium = 24,
  Small = 16
}
